function formatMinutes(totalMinutes: number): string {
  const hours = Math.floor(totalMinutes / 60) % 24;
  const minutes = totalMinutes % 60;
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
    2,
    "0"
  )}`;
}

export function addOneHour(start: string): string {
  const [hours, minutes] = start.split(":").map(Number);
  return formatMinutes(hours * 60 + minutes + 60);
}

export function generateSlotStarts(
  startHour: number,
  endHour: number,
  intervalMinutes = 60
): string[] {
  if (intervalMinutes <= 0) return [];

  const starts: string[] = [];
  const lastStartMinutes = (endHour - 1) * 60;

  for (
    let minutes = startHour * 60;
    minutes <= lastStartMinutes;
    minutes += intervalMinutes
  ) {
    starts.push(formatMinutes(minutes));
  }

  return starts;
}

export function toIsoDate(date: Date | null): string {
  if (!date) return "";
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date
    .getDate()
    .toString()
    .padStart(2, "0");
  return `${year}-${month}-${day}`;
}
